import React, { useState, useEffect, useRef, useContext } from "react";
import { C4FStatusContext, InfoModalContext, UserInformationContext, SitterUserInformationContext, ReferenceDataContext, EventContext } from "../main/App";
import { Link } from "react-router-dom";
import { ButtonGroup, Button, Row, Container, Table } from 'react-bootstrap';
import { getRankAcronym, getRankSymbol } from "../user/C4FRanks";
import { getJersey } from "../race/C4FLeaderJerseys";
import C4FSimpleTable from "../common/C4FSimpleTable";
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import config from "../etc/config.json";
import '../css/general.css';
import moment from 'moment';
import { getC4FCodeForCountryCode, getUnicodeFlag, getUnicodeOrImageFlagForLanguage, getRegularTeam, average, isReadyForSelection as isNationalTeamSelectionOpen, hasNationalTeam, getNationalTeamSelectionTime, formatLocalDateTime } from "../common/Helpers";

function TeamInfo(props) {

    const mounted = useRef(false);
    const { handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
    const { userInformation, setUserInformation } = useContext(UserInformationContext);
    const { sitterUserInformation } = useContext(SitterUserInformationContext);
    const { showRiderInfo, showTeamInfo } = useContext(InfoModalContext);
    const { countries } = useContext(ReferenceDataContext);
    const { events } = useContext(EventContext);
    const [owner, setOwner] = useState(null);
    const [team, setTeam] = useState(null);
    const [teamTransfers, setTeamTransfers] = useState([]);
    const [teamTransfersComplete, setTeamTransfersComplete] = useState(false);
    const [teamTransfersInfo, setTeamTransfersInfo] = useState('');
    const [teamPalmares, setTeamPalmares] = useState([]);
    const [teamPalmaresComplete, setTeamPalmaresComplete] = useState(false);
    const [teamPalmaresInfo, setTeamPalmaresInfo] = useState('');
    const [teamExRiders, setTeamExRiders] = useState([]);
    const [teamTab, setTeamTab] = useState('riders');

    const [teamFairplay, setTeamFairplay] = useState([]);
    const [teamFairplayComplete, setTeamFairplayComplete] = useState(false);
    const [teamFairplayInfo, setTeamFairplayInfo] = useState('');

    const isOwnTeam = () => {
        return userInformation && getRegularTeam(userInformation).id === props.teamId
    }

    function loadTeam() {
        handleBackendRequest('GET', '/team/' + props.teamId, null,
            {
                searchById: true,
                returnRiders: true,
                returnRaceStatistics: true,
                returnSeasonStatistics: true,
                returnPrivateInfo: isOwnTeam()
            },
            function (team) {
                if (team.owner > 0)
                    handleBackendRequest('GET', '/user/' + team.owner, null, { searchById: true }, setOwner);
                setTeam(team);
                if (team.type === 'NationalTeam' && isNationalTeamSelectionOpen(events))
                    setTeamTab('overview');
            }
        );
    }

    function createNCRequest(rider) {
        if (rider.nationsCommitteeResult !== 'None' || !rider.named) return;
        handleBackendRequest('POST', '/rider/' + rider.id + '/createNationsCommitteeRequest', null, null,
            function () {
                let teamLocal = team;
                let riderLocal = team.riders.find(r => r.id === rider.id);
                riderLocal.nationsCommitteeResult = 'Open';
                setTeam(teamLocal);
            }, false);
    }

    function handleTeamPalmaresResponse(teamPalmares, pageSize) {
        setTeamPalmares(teamPalmares.palmares);
        if (teamPalmares.palmares.length < pageSize || pageSize === 0)
            setTeamPalmaresComplete(true);
        setTeamPalmaresInfo('Loaded ' + teamPalmares.palmares.length + ' most recent palmarés records');
    }

    function handleTeamPalmares(pageSize) {
        if (teamPalmares.length === 0 || pageSize === 0) {

            handleBackendRequest('GET', '/team/' + props.teamId, null, { returnPalmares: true, pageSize: pageSize, searchById: true },
                function (teamPalmares) { handleTeamPalmaresResponse(teamPalmares, pageSize); });
        }
        if (teamTab !== 'palmares') setTeamTab('palmares');
    }

    function handleTeamTransfersResponse(teamResponse, pageSize) {
        setTeamTransfers(teamResponse.transfers);
        if (teamResponse.transfers.length < pageSize || pageSize === 0)
            setTeamTransfersComplete(true);
        setTeamTransfersInfo('Loaded ' + teamResponse.transfers.length + ' most recent transfer records');
    }
    function handleTeamTransfers(pageSize) {
        if (teamTransfers.length === 0 || pageSize === 0) {
            handleBackendRequest('GET', '/team/' + props.teamId, null, { returnTransfers: true, pageSize: pageSize, searchById: true },
                function (teamResponse) { handleTeamTransfersResponse(teamResponse, pageSize); });
        }
        if (teamTab !== 'transfers') setTeamTab('transfers');
    }

    function handleTeamFairplayResponse(teamResponse, pageSize) {
        setTeamFairplay(teamResponse.fairplay);
        if (teamResponse.fairplay.length < pageSize || pageSize === 0)
            setTeamFairplayComplete(true);
        setTeamFairplayInfo('Loaded ' + teamResponse.fairplay.length + ' most recent fairplay records');
    }
    function handleTeamFairplay(pageSize) {
        if (teamFairplay.length === 0 || pageSize === 0) {
            handleBackendRequest('GET', '/team/' + props.teamId, null, { returnFairplay: true, pageSize: pageSize, searchById: true },
                function (teamResponse) { handleTeamFairplayResponse(teamResponse, pageSize); });
        }
        if (teamTab !== 'fairplay') setTeamTab('fairplay');
    }

    function handleTeamRiders() {
        setTeamTab('riders');
    }

    function handleTeamRiderStats() {
        setTeamTab('riderstats');
    }

    function handleTeamExRiders() {
        setTeamTab('exriders');
        if (teamExRiders.length === 0)
            handleBackendRequest('GET', '/team/' + props.teamId, null, 
                { 
                    returnExRiders: true, 
                    returnRaceStatistics: true,
                    searchById: true 
                },
                function (teamResponse) {
                    setTeamExRiders(teamResponse.riders);
                });
    }

    function getNCResultSignal(ncResult) {
        switch (ncResult) {
            case 'None': return '\u26AA';
            case 'Open': return '\uD83D\uDFE1';
            case 'Accepted': return '\uD83D\uDFE2';
            default: return '\uD83D\uDD34';
        }
    }

    function handleShowFromTeamInfo(fairplayRecord) {
        showTeamInfo({ teamId: fairplayRecord.fromTeamId, teamName: fairplayRecord.fromTeam});
    }
    function handleShowToTeamInfo(fairplayRecord) {
        showTeamInfo({ teamId: fairplayRecord.toTeamId, teamName: fairplayRecord.toTeam});
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            if (props.teamId !== null)
                loadTeam();
        }
        else {
        }
    }, [props.teamId]);

    function getJerseyFileName(team) {
        if (team.type === 'NationalTeam')
            return config.SUBDIR_NATIONALJERSEYS + 'trikot_' + getC4FCodeForCountryCode(countries, team.homeCountry) + '.png';
        else 
            return config.SUBDIR_USERJERSEYS + 'trikot_' + team.id + '.png';
    }

    function handleSelectReleaseNationalTeamResponse(teamResponse) {
        handleBackendRequest('GET', '/user/' + userInformation.userName, null, null, 
            function (userResponse) {
                setUserInformation(userResponse);
                setOwner(teamResponse.owner ? userResponse : null);                
            });
        setTeam(teamResponse);
    }

    function handleSelectNationalTeam() {
        handleBackendRequest('POST', '/team/' + props.teamId + '/select', null, 
            {
                userId: userInformation.userID
            },
            handleSelectReleaseNationalTeamResponse);
    }

    function handleReleaseNationalTeam() {
        handleBackendRequest('POST', '/team/' + props.teamId + '/release', null, 
            {
                userId: userInformation.userID
            },
            handleSelectReleaseNationalTeamResponse);
    }

    if (team)
        return <div className="container-fluid m-0 p-0 justify-content-center">
            <div className="row d-flex mt-1 m-0 p-1 justify-content-center">
                <img alt="jersey" src={config.DIR_JERSEYS + getJerseyFileName(team)} style={{ maxHeight: 50 }} />
                <h2>&nbsp;{team.teamName + ' (' + team.acronym + ')'}</h2>
                {team.type === 'Regular' && owner ?
                    <table>
                        <thead>
                            {owner.roles.filter(role => !['Owner', 'Developer'].includes(role)).map(role =>
                                <th key={'th' + role} style={{ textAlign: "center" }}>
                                    <img alt={role} src={getRankSymbol(role)} style={{ maxHeight: "24px" }}></img>
                                </th>
                            )}
                        </thead>
                        <tbody>
                            {owner.roles.map(role =>
                                <td key={'td' + role} style={{ textAlign: "center" }}>{getRankAcronym(role)}</td>
                            )}
                        </tbody>
                    </table>
                : null }
            </div>
            {team.type === 'Regular' && owner ?
                <div className="row d-flex m-0 p-1 justify-content-center">
                    <i>"{owner.motto}"</i>
                </div>
            : null }
            <Row className="justify-content-center my-1">
                <ButtonGroup>
                    <Button className="py-0 px-2" variant={(teamTab === 'overview') ? 'primary' : 'outline-primary'}
                        onClick={() => setTeamTab('overview')}>Team</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'riders') ? 'primary' : 'outline-primary'}
                        onClick={() => handleTeamRiders()}>Riders</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'riderstats') ? 'primary' : 'outline-primary'}
                        onClick={() => handleTeamRiderStats()}>Stats</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'exriders') ? 'primary' : 'outline-primary'}
                        onClick={() => handleTeamExRiders()} disabled={team.type === 'NationalTeam'}>ExRiders</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'palmares') ? 'primary' : 'outline-primary'}
                        onClick={() => handleTeamPalmares(50)}>Palmarès</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'transfers') ? 'primary' : 'outline-primary'}
                        onClick={() => handleTeamTransfers(50)} disabled={team.type === 'NationalTeam'}>Transfers</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'fairplay') ? 'primary' : 'outline-primary'}
                        onClick={() => handleTeamFairplay(50)} disabled={team.type === 'NationalTeam'}>Fairplay</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'seasonStats') ? 'primary' : 'outline-primary'}
                        onClick={() => setTeamTab('seasonStats')} disabled={team.type === 'NationalTeam'}>Seasons</Button>
                    <Button className="py-0 px-2" variant={(teamTab === 'riderdetails') ? 'primary' : 'outline-primary'}
                        onClick={() => setTeamTab('riderdetails')} hidden>Detail</Button>
                </ButtonGroup>
            </Row>
            {(() => {
                if (teamTab === 'overview')
                    return <div className="row d-flex mt-1 p-1 justify-content-center" style={{ maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                        <div className="col m-1 p-1 centered" style={{ minWidth: 300, maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                            <Table size="sm" key="teamInfo" striped>
                                <tbody>
                                    <tr>
                                        <td><b><u>INFO</u></b></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><b>Name (ID)</b></td>
                                        <td>{team.teamName + ' (' + team.id + ')'}</td>
                                    </tr>
                                    <tr>
                                        <td><b>First Race</b></td>
                                        <td>{moment(team.raceStatistics.FirstRace).format('dd, DD MMMM YYYY')}</td>
                                    </tr>
                                    {owner ? 
                                        <>
                                            <tr>
                                                <td><b>Owner (ID)</b></td>
                                                <td>
                                                    {owner.userName + ' (' + owner.userID + ')'}
                                                    {team.type === 'NationalTeam' && userInformation && !sitterUserInformation && owner.userID === userInformation.userID ? 
                                                        <Button className="py-0" size="sm" variant="danger" onClick={() => handleReleaseNationalTeam()}>Release</Button>                                                        
                                                    : null }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><b>Language</b></td>
                                                <td>{getUnicodeOrImageFlagForLanguage(countries, owner.language, browserInfo)}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Last Login</b></td>
                                                <td>{moment(new Date(owner.lastLogin)).format('dd, DD MMMM YYYY')}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Forum Account</b></td>
                                                <td>{owner.forumAccount}</td>
                                            </tr>
                                        </>
                                    : 
                                    (team.type === 'NationalTeam' && userInformation && !sitterUserInformation && isNationalTeamSelectionOpen(events, userInformation)) ? 
                                        <tr>
                                            <td><b>Owner (ID)</b></td>
                                            <td>
                                                {getNationalTeamSelectionTime(events, userInformation) < new Date() ? 
                                                    <Button className="py-0" size="sm" 
                                                        variant="primary"
                                                        onClick={() => handleSelectNationalTeam()}>Select Team</Button>
                                                    :
                                                    <Button className="py-0" size="sm" disabled
                                                        variant="outline-primary"
                                                        onClick={() => handleSelectNationalTeam()}>Select Team ({formatLocalDateTime(getNationalTeamSelectionTime(events, userInformation))})</Button>
                                                }
                                            </td>
                                        </tr>
                                    : null }
                                </tbody>
                            </Table>
                            <Table key="teamStats" size="sm" striped>
                                <tbody>
                                    <tr>
                                        <td><b><u>STATS</u></b></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><b>Division</b></td>
                                        <td>{team.division}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Season Points</b></td>
                                        <td>{team.pointsCurrent.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Season Races</b></td>
                                        <td>{team.raceStatistics.SeasonRaces}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Team Value</b></td>
                                        <td>{(team.teamValue - team.balance).toLocaleString("en-EN", { style: "currency", currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0 })}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Points {'\u221E'}</b></td>
                                        <td>{team.pointsEternal.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Races {'\u221E'}</b></td>
                                        <td>{team.raceStatistics.TotalRaces.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u2300'} Races</b></td>
                                        <td>{(team.pointsEternal / team.raceStatistics.TotalRaces).toLocaleString(navigator.language, { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        <div className="col m-1 p-1 centered" style={{ minWidth: 300, maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                            <Table key="teamAvg" size="sm" striped>
                                <tbody>
                                    <tr>
                                        <td><b><u>AVERAGES</u></b></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u03A3'} Riders</b></td>
                                        <td>{team.riders.length}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Climbing</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.skills.Climbing))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Flat</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.skills.Flat))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Downhill</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.skills.Downhill))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} TimeTrial</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.skills.TimeTrial))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Sprint</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.skills.Sprint))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Pavé</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => 0.7 * r.skills.Flat + 0.3 * r.skills.Cobbles))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Regeneration</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.skills.Regeneration))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Age</b></td>
                                        <td>{Math.round(10 * average(team.riders.map(r => r.age))) / 10}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Rider Salary</b></td>
                                        <td>{Math.round(average(team.riders.map(r => r.salary)) / 1).toLocaleString("en-EN", { style: "currency", currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0 })}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\u00D8'} Rider Value</b></td>
                                        <td>{Math.round(average(team.riders.map(r => r.marketValue)) / 1).toLocaleString("en-EN", { style: "currency", currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0 })}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        <div className="col m-1 p-1 centered" style={{ minWidth: 300, maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                            <Table key="teamPalmares" size="sm" striped >
                                <tbody>
                                    <tr>
                                        <td><b><u>PALMARÈS</u></b></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\uD83C\uDFC6'}Race Wins</b></td>
                                        <td>{team.raceStatistics.RaceWins.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\uD83C\uDFC6'}Classic Wins</b></td>
                                        <td>{team.raceStatistics.ClassicWins}</td>
                                    </tr>
                                    <tr>
                                        <td><b><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}Stage Race Wins</b></td>
                                        <td>{team.raceStatistics.StageRaceWins}</td>
                                    </tr>
                                    <tr>
                                        <td><b>{'\uD83E\uDD48 \uD83E\uDD49'}Stage Race Podiums</b></td>
                                        <td>{team.raceStatistics.StageRacePodiums}</td>
                                    </tr>
                                    <tr>
                                        <td><b><img alt="GCLeader" title="Points Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />Points Jerseys</b></td>
                                        <td>{team.raceStatistics.SprintJerseys}</td>
                                    </tr>
                                    <tr>
                                        <td><b><img alt="GCLeader" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />Mountain Jerseys</b></td>
                                        <td>{team.raceStatistics.MountainJerseys}</td>
                                    </tr>
                                    <tr>
                                        <td><b><img alt="GCLeader" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />Youth Jerseys</b></td>
                                        <td>{team.raceStatistics.YouthJerseys}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Team Classifications</b></td>
                                        <td>{team.raceStatistics.TeamClassifications}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            {(team.nameChanges.length > 0) ?
                                <Table key="teamNameChanges" size="sm" striped >
                                    <tbody>
                                        <tr>
                                            <td><b><u>NAME CHANGES</u></b></td>
                                            <td></td>
                                        </tr>
                                        {team.nameChanges.map((nameChange) => (
                                            <tr>
                                                <td>{moment(nameChange.date).format('DD-MMM-YYYY')}</td>
                                                <td>{nameChange.teamName}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td>First Name</td>
                                            <td>{team.nameChanges[team.nameChanges.length - 1].previousTeamName}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                :
                                <></>
                            }
                        </div>
                    </div>
                else if ((teamTab === 'riders' && team.riders.length > 0))
                    return <div className="container-fluid c4f-stats">
                        <div className="row d-flex c4f-stats">
                            <div className="col m-0 p-0">
                                <h5>Riders</h5>
                                <p>The table shows active riders.</p>
                            </div>
                        </div>
                        <div className="row d-flex c4f-stats">
                            <C4FSimpleTable key={'riders'}
                                initialSortingColumn={'riderName'}
                                initialSortingAscending={true}
                                refreshTable={loadTeam}
                                maxHeight={600}
                                data={team.riders.map(record => ({
                                    ...record,
                                    flag: getUnicodeFlag(record.nationality),
                                    c4fCode: getC4FCodeForCountryCode(countries, record.nationality),
                                    riderName: record.firstNames + String.fromCharCode(160) + record.lastNames,
                                    jerseys: record.jerseys.map(jersey => <img alt={jersey} title={jersey} src={getJersey('', jersey)} style={{ maxHeight: "18px" }} />),
                                    climbing: record.skills.Climbing,
                                    flat: record.skills.Flat,
                                    downhill: record.skills.Downhill,
                                    timeTrial: record.skills.TimeTrial,
                                    sprint: record.skills.Sprint,
                                    cobblesCalculated: 0.7 * record.skills.Flat + 0.3 * record.skills.Cobbles,
                                    regeneration: record.skills.Regeneration,
                                    energy: isOwnTeam() ? Math.round(record.energy / 10) : 'n/a',
                                    form: isOwnTeam() ? record.formCurrent + ((record.formTendency > 0) ? '+' : ((record.formTendency === 0) ? '' : '-')) : 'n/a',
                                    ncResult: getNCResultSignal(record.nationsCommitteeResult)
                                }))}
                                rowMetadata={
                                    [browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                                        { columnName: 'flag', columnDescription: '\u2691', columnGroup: 'Overview' }
                                        :
                                        { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag', columnGroup: 'Overview' }]
                                        .concat(userInformation !== null && userInformation.roles.some(role => ['Admin', 'NationsCommittee'].includes(role)) ?
                                            [{ columnName: 'ncResult', columnDescription: 'NC', columnGroup: 'Overview', cellClickEvent: createNCRequest }]
                                            :
                                            [])
                                        .concat([
                                            { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                                            { columnName: 'nickname', columnDescription: 'Nickname', columnGroup: 'Overview' },
                                            { columnName: 'jerseys', columnDescription: <img alt={'jersey'} src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px" }} />, columnGroup: 'Overview', columnType: 'object' },
                                            { columnName: 'age', columnDescription: 'Age', columnGroup: 'Overview' },
                                            { columnName: 'salary', columnDescription: 'Salary', columnGroup: 'Overview', columnType: 'currency' },
                                            { columnName: 'marketValue', columnDescription: 'Value', columnGroup: 'Overview', columnType: 'currency' }
                                        ])
                                        .concat([
                                            { columnName: 'climbing', columnDescription: 'Climbing', columnHeader: <img src={SkillClimbing} title="Mountain" alt="Climbing" />, columnGroup: 'Skills' },
                                            { columnName: 'flat', columnDescription: 'Flat', columnHeader: <img src={SkillFlat} title="Flat" alt="Flat" />, columnGroup: 'Skills' },
                                            { columnName: 'downhill', columnDescription: 'Downhill', columnHeader: <img src={SkillDownhill} title="Downhill" alt="Downhill" />, columnGroup: 'Skills' },
                                            { columnName: 'timeTrial', columnDescription: 'TimeTrial', columnHeader: <img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" />, columnGroup: 'Skills' },
                                            { columnName: 'sprint', columnDescription: 'Sprint', columnHeader: <img src={SkillSprint} title="Sprint" alt="Sprint" />, columnGroup: 'Skills' },
                                            { columnName: 'cobblesCalculated', columnDescription: 'Cobbles', columnHeader: <img src={SkillCobbles} title="Cobbles" alt="Cobbles" />, columnGroup: 'Skills' },
                                            { columnName: 'regeneration', columnDescription: 'Regeneration', columnHeader: <img src={SkillRegeneration} title="Regeneration" alt="Regeneration" />, columnGroup: 'Skills' }
                                        ])
                                        .concat(isOwnTeam() ? [
                                            { columnName: 'energy', columnDescription: 'Energy', columnGroup: 'Skills', columnType: 'energy' },
                                            { columnName: 'form', columnDescription: 'Form', columnGroup: 'Skills' }
                                        ] : [])
                                }
                            />
                        </div>
                    </div>
                else if (teamTab === 'riders' && team.riders.length === 0 && isOwnTeam())
                    return <div className="container-fluid c4f-stats">
                        <div className="row d-flex c4f-stats">
                            <div className="col m-0 p-0">
                                <h5>Riders</h5>
                                <p>There are currently 0 riders in your team.</p>
                                <br />
                                <br />
                                <h5 id="market_team">How to buy riders?</h5>
                                <p>As a new team, or after a team-reset, you can either create an <b>automatic team</b> or <b>custom team.</b></p>
                                <h5 id="market_autoteam">Automatic Team</h5>
                                <p>This is recommended for newcomers. The automatic teams allow a quick start with a competitive team that can win races:</p>
                                <ol>
                                    <li>You select a team type: Sprint Team, Climbing Team, Classics Team or Allround Team.</li>
                                    <li>You receive 9 riders plus additional 2,500,000 - 5,000,000 budget for new transfers.</li>
                                    <li>You choose the nationality and the name of each rider.</li>
                                </ol>
                                <p><b>How To:</b> Go to <Link to="/profile">Profile</Link>➝Auto-Team to find more information and generate your automatic team.</p>
                                <br />
                                <h5 id="market_individual">Custom Team</h5>
                                <p>This is recommended only for experienced managers. To have your own custom team setup, you can buy individual riders on the transfer market.</p>
                                <ol>
                                    <li>It is recommended, that you buy at least 10 riders.</li>
                                    <li>You can buy riders which were sold from other teams or you buy new riders without a nationality and without a name ("name geben" in German means "give him a name").</li>
                                    <li>For those new riders, you choose the nationality and the name of each rider.</li>
                                </ol>
                                <p><b>How To:</b> Go to <Link to="/transfermarket">Market</Link> to search for riders and buy riders. Below you find more details on how the transfer market works.</p>
                            </div>
                        </div>
                    </div>
                else if (teamTab === 'riderstats')
                    return <div className="container-fluid c4f-stats">
                        <div className="row d-flex c4f-stats">
                            <div className="col m-0 p-0">
                                <h5>Rider Stats</h5>
                                <p>This table shows active riders with their stats and palmares.</p>
                            </div>
                        </div>
                        <div className="row d-flex c4f-stats">
                            <C4FSimpleTable key={'riderstats'}
                                initialSortingColumn={'pointsCurrent'}
                                initialSortingAscending={false}
                                data={team.riders.map(record => ({
                                    ...record,
                                    flag: getUnicodeFlag(record.nationality),
                                    c4fCode: getC4FCodeForCountryCode(countries, record.nationality),
                                    riderName: record.firstNames + String.fromCharCode(160) + record.lastNames,
                                    pointsCurrent: record.age > 20 ? record.pointsCurrentSeason + record.pointsPreviousSeason : 0,
                                    pointsEternal: record.age > 20 ? record.pointsEternal : 0,
                                    pointsPerRace: record.age > 20 ? record.pointsEternal / record.raceStatistics.TotalRaces : 0,
                                    totalRaces: record.age > 20 ? record.raceStatistics.TotalRaces : 0,
                                    raceWins: record.age > 20 ? record.raceStatistics.RaceWins : 0,
                                    stageRaceWins: record.age > 20 ? record.raceStatistics.StageRaceWins : 0,
                                    stageRacePodiums: record.age > 20 ? record.raceStatistics.StageRacePodiums : 0,
                                    sprintJerseys: record.age > 20 ? record.raceStatistics.SprintJerseys : 0,
                                    mountainJerseys: record.age > 20 ? record.raceStatistics.MountainJerseys : 0,
                                    youthJerseys: record.age > 20 ? record.raceStatistics.YouthJerseys : 0,
                                }))}
                                rowMetadata={[
                                    browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                                        { columnName: 'flag', columnDescription: '\u2691', columnGroup: 'Overview' }
                                        :
                                        { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag', columnGroup: 'Overview' },
                                    { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                                    { columnName: 'age', columnDescription: 'Age', columnGroup: 'Overview' },
                                    { columnName: 'salary', columnDescription: 'Salary', columnGroup: 'Overview', columnType: 'currency' },
                                    { columnName: 'marketValue', columnDescription: 'Value', columnGroup: 'Overview', columnType: 'currency' }
                                ]
                                    .concat([
                                        { columnName: 'pointsCurrent', columnDescription: 'Points', columnGroup: 'Stats' },
                                        { columnName: 'pointsEternal', columnDescription: 'Points \u221E', columnGroup: 'Stats' },
                                        { columnName: 'totalRaces', columnDescription: 'Races \u221E', columnGroup: 'Stats' },
                                        { columnName: 'pointsPerRace', columnDescription: '\u2300 Points', columnGroup: 'Stats' },
                                        { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6', columnGroup: 'Palmarès' },
                                        {
                                            columnName: 'stageRaceWins',
                                            columnDescription: 'Tour Wins',
                                            columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}</>,
                                            columnGroup: 'Palmarès'
                                        },
                                        {
                                            columnName: 'stageRacePodiums',
                                            columnDescription: 'Tour Podiums',
                                            columnHeader: <>{'\uD83E\uDD48\uD83E\uDD49'}</>,
                                            columnGroup: 'Palmarès'
                                        },
                                        {
                                            columnName: 'sprintJerseys',
                                            columnDescription: 'Sprint Jerseys',
                                            columnHeader: <img alt="Sprint" title="Sprint Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                                            columnGroup: 'Palmarès'
                                        },
                                        {
                                            columnName: 'mountainJerseys',
                                            columnDescription: 'Mountain Jerseys',
                                            columnHeader: <img alt="Mountain" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                                            columnGroup: 'Palmarès'
                                        },
                                        {
                                            columnName: 'youthJerseys',
                                            columnDescription: 'Youth Jerseys',
                                            columnHeader: <img alt="Youth" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                                            columnGroup: 'Palmarès'
                                        }
                                    ])}
                            />
                        </div>
                    </div>
                else if (teamTab === 'exriders')
                    return <div className="container-fluid c4f-stats">
                        <div className="row d-flex c4f-stats">
                            <div className="col m-0 p-0">
                                <h5><u>Statistics at Retirement</u></h5>
                            </div>
                        </div>
                        <div className="row d-flex c4f-stats">
                            <C4FSimpleTable key={'exriders'}
                                initialSortingColumn={'pointsEternal'}
                                initialSortingAscending={false}
                                indexColumn={true}
                                data={teamExRiders.map(record => ({
                                    ...record,
                                    flag: getUnicodeFlag(record.nationality),
                                    c4fCode: getC4FCodeForCountryCode(countries, record.nationality),
                                    riderName: record.firstNames + String.fromCharCode(160) + record.lastNames,
                                    climbing: record.skills.Climbing,
                                    flat: record.skills.Flat,
                                    downhill: record.skills.Downhill,
                                    timeTrial: record.skills.TimeTrial,
                                    sprint: record.skills.Sprint,
                                    cobblesCalculated: 0.7 * record.skills.Flat + 0.3 * record.skills.Cobbles,
                                    regeneration: record.skills.Regeneration,
                                    pointsEternal: record.pointsEternal,
                                    pointsPerRace: record.pointsEternal / record.raceStatistics.TotalRaces,
                                    totalRaces: record.raceStatistics.TotalRaces,
                                    raceWins: record.raceStatistics.RaceWins,
                                    stageRaceWins: record.raceStatistics.StageRaceWins,
                                    stageRacePodiums: record.raceStatistics.StageRacePodiums,
                                    sprintJerseys: record.raceStatistics.SprintJerseys,
                                    mountainJerseys: record.raceStatistics.MountainJerseys,
                                    youthJerseys: record.raceStatistics.YouthJerseys
                                }))}
                                rowMetadata={[
                                    browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                                        { columnName: 'flag', columnDescription: '\u2691', columnGroup: 'Overview' }
                                        :
                                        { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag', columnGroup: 'Overview' },
                                    { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                                    { columnName: 'nickname', columnDescription: 'Nickname', columnGroup: 'Overview' },
                                    { columnName: 'age', columnDescription: 'Age', columnGroup: 'Overview' },
                                    { columnName: 'climbing', columnDescription: 'Climbing', columnHeader: <img src={SkillClimbing} title="Mountain" alt="Climbing" />, columnGroup: 'Skills' },
                                    { columnName: 'flat', columnDescription: 'Flat', columnHeader: <img src={SkillFlat} title="Flat" alt="Flat" />, columnGroup: 'Skills' },
                                    { columnName: 'downhill', columnDescription: 'Downhill', columnHeader: <img src={SkillDownhill} title="Downhill" alt="Downhill" />, columnGroup: 'Skills' },
                                    { columnName: 'timeTrial', columnDescription: 'TimeTrial', columnHeader: <img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" />, columnGroup: 'Skills' },
                                    { columnName: 'sprint', columnDescription: 'Sprint', columnHeader: <img src={SkillSprint} title="Sprint" alt="Sprint" />, columnGroup: 'Skills' },
                                    { columnName: 'cobblesCalculated', columnDescription: 'Cobbles', columnHeader: <img src={SkillCobbles} title="Cobbles" alt="Cobbles" />, columnGroup: 'Skills' },
                                    { columnName: 'regeneration', columnDescription: 'Regeneration', columnHeader: <img src={SkillRegeneration} title="Regeneration" alt="Regeneration" />, columnGroup: 'Skills' },
                                    { columnName: 'pointsEternal', columnDescription: 'Points \u221E', columnGroup: 'Stats' },
                                    { columnName: 'totalRaces', columnDescription: 'Races \u221E', columnGroup: 'Stats' },
                                    { columnName: 'pointsPerRace', columnDescription: '\u2300 Points', columnGroup: 'Stats' },
                                    { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6', columnGroup: 'Palmarès' },
                                    {
                                        columnName: 'stageRaceWins',
                                        columnDescription: 'Tour Wins',
                                        columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}</>,
                                        columnGroup: 'Palmarès'
                                    },
                                    {
                                        columnName: 'stageRacePodiums',
                                        columnDescription: 'Tour Podiums',
                                        columnHeader: <>{'\uD83E\uDD48 \uD83E\uDD49'}</>,
                                        columnGroup: 'Palmarès'
                                    },
                                    {
                                        columnName: 'sprintJerseys',
                                        columnDescription: 'Sprint Jerseys',
                                        columnHeader: <img alt="Sprint" title="Sprint Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                                        columnGroup: 'Palmarès'
                                    },
                                    {
                                        columnName: 'mountainJerseys',
                                        columnDescription: 'Mountain Jerseys',
                                        columnHeader: <img alt="Mountain" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                                        columnGroup: 'Palmarès'
                                    },
                                    {
                                        columnName: 'youthJerseys',
                                        columnDescription: 'Youth Jerseys',
                                        columnHeader: <img alt="Youth" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                                        columnGroup: 'Palmarès'
                                    }
                                ]}
                            />
                        </div>
                    </div>
                else if (teamTab === 'palmares')
                    return <div className="row d-flex mt-1 p-1 justify-content-center" style={{ maxHeight: 700, overflow: "auto", backgroundColor: 'rgba(222, 233, 244)' }}>
                        <div className="col m-1 justify-content-center" style={{ minWidth: 400, maxHeight: 700 }}>
                            <h5><u>Palmarès</u></h5>
                            {teamPalmaresInfo}.&nbsp;
                            {teamPalmaresComplete ?
                                <Button variant="primary py-0" disabled>All records loaded</Button>
                                :
                                <Button variant="primary py-0" onClick={() => handleTeamPalmares(0)}>Load all records</Button>
                            }
                            <Container className="c4f-stats">
                                <Row className="c4f-stats ">
                                    <C4FSimpleTable key={'teamPalmares'}
                                        initialSortingColumn={'date'}
                                        initialSortingAscending={false}
                                        data={teamPalmares}
                                        rowMetadata={[
                                            { columnName: 'date', columnDescription: 'Date' },
                                            { columnName: 'type', columnDescription: 'Type' },
                                            { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                                            { columnName: 'raceName', columnDescription: 'Race' },
                                            { columnName: 'category', columnDescription: 'Cat.' },
                                            { columnName: 'group', columnDescription: 'Group' }
                                        ]}
                                    />
                                </Row>
                            </Container>
                        </div>
                    </div>
                else if (teamTab === 'transfers')
                    return <div className="row d-flex mt-1 p-1 justify-content-center" style={{ maxHeight: 700, overflow: "auto", backgroundColor: 'rgba(222, 233, 244, 1)' }}>
                        <div className="col m-1 justify-content-center" style={{ minWidth: 400, maxHeight: 700 }}>
                            <h5><u>Transfers</u></h5>
                            {teamTransfersInfo}.&nbsp;
                            {teamTransfersComplete ?
                                <Button variant="primary py-0" disabled>All records loaded</Button>
                                :
                                <Button variant="primary py-0" onClick={() => handleTeamTransfers(0)}>Load all records</Button>
                            }
                            <Container className="c4f-stats">
                                <Row className="c4f-stats ">
                                    <C4FSimpleTable key={'transfers'}
                                        initialSortingColumn={'date'}
                                        initialSortingAscending={false}
                                        data={teamTransfers}
                                        rowMetadata={[
                                            { columnName: 'date', columnDescription: 'Date' },
                                            { columnName: 'type', columnDescription: 'Type' },
                                            { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                                            { columnName: 'price', columnDescription: 'Price', columnType: 'currency' }
                                        ]}
                                    />
                                </Row>
                            </Container>
                        </div>
                    </div>
                else if (teamTab === 'fairplay')
                    return <div className="row d-flex mt-1 p-1 justify-content-center" style={{ maxHeight: 700, overflow: "auto", backgroundColor: 'rgba(222, 233, 244, 1)' }}>
                        <div className="col m-1 justify-content-center" style={{ minWidth: 400, maxHeight: 700 }}>
                            <h5><u>Fairplay</u></h5>
                            {teamFairplayInfo}.&nbsp;
                            {teamFairplayComplete ?
                                <Button variant="primary py-0" disabled>All records loaded</Button>
                                :
                                <Button variant="primary py-0" onClick={() => handleTeamFairplay(0)}>Load all records</Button>
                            }
                            <Container className="c4f-stats">
                                <Row className="c4f-stats ">
                                    <C4FSimpleTable key={'fairplay'}
                                        initialSortingColumn={'date'}
                                        initialSortingAscending={false}
                                        data={teamFairplay}
                                        rowMetadata={[
                                            { columnName: 'date', columnDescription: 'Date' },
                                            { columnName: 'fromTeam', columnDescription: 'From', cellClickEvent: handleShowFromTeamInfo },
                                            { columnName: 'toTeam', columnDescription: 'To', cellClickEvent: handleShowToTeamInfo },
                                            { columnName: 'vote', columnDescription: 'Vote', columnType: 'fairplayVote' },
                                            { columnName: 'message', columnDescription: 'Message' }
                                        ]} />
                                </Row>
                            </Container>
                        </div>
                    </div>
                else if (teamTab === 'seasonStats')
                    return <div className="row d-flex mt-1 p-1 justify-content-center" style={{ maxHeight: 700, overflow: "auto", backgroundColor: 'rgba(222, 233, 244, 1)' }}>
                        <div className="col m-1 justify-content-center" style={{ minWidth: 400, maxHeight: 700 }}>
                            <h5><u>Seasons</u></h5>
                            <Container className="c4f-stats">
                                <Row className="c4f-stats ">
                                    <C4FSimpleTable key={'seasonStats'}
                                        initialSortingColumn={'season'}
                                        initialSortingAscending={false}
                                        data={team.seasonStatistics}
                                        rowMetadata={[
                                            { columnName: 'season', columnDescription: 'Season' },
                                            { columnName: 'division', columnDescription: 'Div' },
                                            { columnName: 'position', columnDescription: 'Pos' },
                                            { columnName: 'seasonPoints', columnDescription: 'Points' },
                                            { columnName: 'pointsEternal', columnDescription: 'Points \u221E' },
                                            { columnName: 'races', columnDescription: 'Races' }
                                        ]}
                                    />
                                </Row>
                            </Container>
                        </div>
                    </div>
            })()}
        </div >
    else
        return null;
}

export default TeamInfo;